//------------------------------------------------------------------------------------

const CATERING_DESIGNATIONS = [
	'vendor',
	'stall vendor',
	'stall/trolley vendor',
	'stall & trolley vendor',
	'stall and trolley vendor',
	'trolley vendor',
	'pf vendor',
	'manager',
	'assistant manager',
	'cook',
	'assistant cook',
	'ascook',
	'helper',
	'cleaner',
	'counter boy',
	'service boy',
	'wvm operator',
	'rest giver',
	'waiter',
];

// Counter boy / service boy show up combined in many slash & spacing variants
// (e.g. "Counter Boy / Service Boy", "SERVICEBOY / COUNTER BOY", "Service Boy/Counter Boy"),
// so these two are matched as substrings rather than requiring an exact designation match.
const CATERING_SUBSTRING_TERMS = ['counter boy', 'service boy', 'serviceboy'];

// Firm/unit names containing any of these words are treated as catering businesses,
// regardless of the vendor's individual designation.
const CATERING_UNIT_KEYWORDS = ['caterers', 'catering', 'bakery', 'mahanand'];

const isCateringVendor = (vendor) => {
	const designation = (vendor.desigination || '').toLowerCase().trim();
	const unit = (vendor.unit || '').toLowerCase().trim();

	if (CATERING_DESIGNATIONS.includes(designation)) return true;
	if (CATERING_SUBSTRING_TERMS.some((term) => designation.includes(term))) {
		return true;
	}
	if (CATERING_UNIT_KEYWORDS.some((term) => unit.includes(term))) return true;

	return false;
};

// Restricts a vendor list to what the logged-in admin's department is allowed to see.
// Super admins (and admins with no department set) see everything, unchanged.
const filterVendorsByDepartment = (vendors) => {
	const adminRaw = localStorage.getItem('admin');
	if (!adminRaw) return vendors;

	const admin = JSON.parse(adminRaw);
	if (!admin || admin.superAdmin == 1 || !admin.department) return vendors;

	if (admin.department === 'Catering') {
		return vendors.filter((vendor) => isCateringVendor(vendor));
	}

	if (admin.department === 'Other') {
		return vendors.filter((vendor) => !isCateringVendor(vendor));
	}

	return vendors;
};

export { isCateringVendor };
export default filterVendorsByDepartment;

//------------------------------------------------------------------------------------
